import React from 'react'
import { CheckCircle2, AlertTriangle } from 'lucide-react'

interface AssetStats {
  total: number
  complete: number
  analyzing: number
  errors: number
  passedChecks: number
  warningChecks: number
  failedChecks: number
}

interface AssetStatsBarProps {
  stats: AssetStats
}

export default function AssetStatsBar({ stats }: AssetStatsBarProps) {
  return (
    <div className="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4">
      <div className="flex items-center gap-6 text-sm">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-blue-500"></div>
          <span>{stats.total} Assets</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-green-500"></div>
          <span>{stats.complete} Complete</span>
        </div>
        {stats.analyzing > 0 && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-yellow-500 animate-pulse"></div>
            <span>{stats.analyzing} Processing</span>
          </div>
        )}
        {stats.errors > 0 && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-red-500"></div>
            <span>{stats.errors} Errors</span>
          </div>
        )}
        {stats.passedChecks > 0 && (
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-green-500" />
            <span className="text-green-600 font-medium">{stats.passedChecks} Passed</span>
          </div>
        )}
        {stats.warningChecks > 0 && (
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-yellow-500" />
            <span className="text-yellow-600 font-medium">{stats.warningChecks} Warnings</span>
          </div>
        )}
        {stats.failedChecks > 0 && (
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-red-500" />
            <span className="text-red-600 font-medium">{stats.failedChecks} Failed</span>
          </div>
        )}
      </div>
    </div>
  )
}


